// TemplateListItemMUI.js (New file)
import { AntDesign } from '@expo/vector-icons';
import React from 'react';
import { View, Text, Image, StyleSheet } from 'react-native'; // Use React Native components as needed

// You might not need all props here, only the ones necessary to display the item
// For example, if 'item' from your data is passed directly
type TemplateDisplayItem = {
  label: string;
  dataTitle?: string;
  data?: { name?: string; surname?: string };
  color?: string;
  icon?: string;
  docCount?: number;
  snapShot?: string; // Assuming snapShot comes from your 'template' object now
  _id?: string;
  // Add other properties from your template object that you want to display
};

interface TemplateListItemMUIProps {
  template: TemplateDisplayItem; // Pass the whole template item
}

const TemplateListItemMUI: React.FC<TemplateListItemMUIProps> = ({ template }) => {

  if(!template) {
    return null; // Handle case where template is not provided
  }

  const genLabel = () => {
    if (template.label) {
      return template.label; // Assuming label is already parsed if needed
    }
    if (!template.dataTitle || !template.label) {
      return template.data?.name + ' ' + template.data?.surname || "No Name";
    } else {
      return template.dataTitle || template.label;
    }
  };


  return (
    <View style={muiTemplateItemStyles.container}>
      {template?.snapShot && (
        <Image
          source={{ uri: template.snapShot }}
          style={muiTemplateItemStyles.snapshot}
        />
      )}
      <View style={muiTemplateItemStyles.textContainer}>
        <Text style={muiTemplateItemStyles.titleText}>{genLabel()}</Text>
        <View style={muiTemplateItemStyles.detailsRow}>
          {template.color && (
            <View style={[muiTemplateItemStyles.colorDot, { backgroundColor: template.color }]} />
          )}
          {template.icon && (
            // Assuming AntDesign is imported if you want to use icons here
            // You might need to pass AntDesign from parent or ensure it's available
            <Text style={muiTemplateItemStyles.iconText}>
              <AntDesign name={template.icon} size={16} color="black" />
            </Text>
          )}
          {template.docCount !== undefined && (
            <Text style={muiTemplateItemStyles.docCountText}>{template.docCount}</Text>
          )}
        </View>
      </View>
    </View>
  );
};

const muiTemplateItemStyles = StyleSheet.create({
  container: {
    flexDirection: 'row',
    alignItems: 'center',
    paddingVertical: 5, // Small padding to give some space
    // Do NOT add marginVertical here, MenuItem already handles it
  },
  snapshot: {
    width: 40,
    height: 40,
    borderRadius: 5,
    marginRight: 10,
    resizeMode: 'cover',
  },
  textContainer: {
    flex: 1,
    flexDirection: 'column',
  },
  titleText: {
    fontSize: 16,
    fontWeight: 'bold',
    color: 'black', // Default text color
  },
  detailsRow: {
    flexDirection: 'row',
    alignItems: 'center',
    marginTop: 2,
  },
  colorDot: {
    width: 10,
    height: 10,
    borderRadius: 5,
    marginRight: 5,
  },
  iconText: {
    marginRight: 5,
  },
  docCountText: {
    fontSize: 12,
    color: 'grey',
  },
});

export default React.memo(TemplateListItemMUI);